import { render, staticRenderFns } from "./Radarr.vue?vue&type=template&id=3b5d03e8&scoped=true&"
import script from "./Radarr.vue?vue&type=script&lang=js&"
export * from "./Radarr.vue?vue&type=script&lang=js&"
import style0 from "./Radarr.vue?vue&type=style&index=0&id=3b5d03e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d03e8",
  null
  
)

export default component.exports